export default {
  priv: 'pr_device',
  overviewTitle: 'Goedkeuringsnummers',
  detailTitle: 'Goedkeuringsnummer',
  deleteTitle: 'deze nummer',
  url: '/devices/approvalnumbers',
  apiUrl: '/deviceapprovals/',
  sortBy: ['code'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'deviceapprovalnumbers',
  quickFilter: {
    text: 'Zoek op naam',
    value: 'desc',
    type: 'text'
  },
  newRecord: {
    parts: [],
    is_active: true
  },
  tableFields: [
    {
      text: 'Code',
      value: 'code',
      link: '/devices/approvalnumbers/{id}',
      width: '20%'
    },
    {
      text: 'Omschrijving',
      value: 'desc',
      width: '30%'
    },
    {
      text: 'Datum',
      value: 'date',
      width: '20%',
      filter: 'date'
    },
    {
      text: 'Versie',
      value: 'version',
      width: '20%'
    }
  ]
};
